<style scoped>

</style>
<template>
  <div>
    <div class="line">
      <RadioGroup
        v-model="params.search_type"
        type="button"
        @on-change="searchTypeChange"
      >
        <Radio label="pending">
          待我处理
        </Radio>
        <Radio label="related">
          所有记录
        </Radio>
      </RadioGroup>
      <Button
        type="primary"
        :disabled="select_topics.length < 2"
        @click="batchPass"
      >
        批量通过
      </Button>
    </div>
    <Table
      size="small"
      :columns="columns"
      :data="director_topics"
      :loading="loading"
      @on-selection-change="selectChange"
    />

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>

    <Modal
      v-model="config.modal"
      width="500"
      cancel-text=""
    >
      <div slot="header">
        {{ cur_director_topic.director.account }} 提交的工资
      </div>
      <Table
        size="small"
        :columns="record_columns"
        :data="cur_director_topic.records"
      />
    </Modal>
  </div>
</template>
<script route="/team/outsource_wage_audit">
  import FlowUtil from '../../libs/flow_util';
  import UserFlowBase from '../components/flow/user_flow_base';
  import ViewerItem from '../components/viewer/item';

  export default {
    /* router_info_start */
    router_info: '/team/outsource_wage_audit',
    /* router_info_end */
    components: { UserFlowBase, ViewerItem },
    data() {
      return {
        loading: false,
        batching: false,
        params: {
          search_type: 'pending',
          page: 1,
          per_page: 30
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        director_topics: [],
        select_topics: [],
        cur_director_topic: {director: {}, records: []},
        config: { modal: false },
        columns: [
          {
            type: 'selection',
            width: 50,
            align: 'center',
          },
          {
            title: '明细',
            width: 60,
            render: (h, params) => {
              const director_topic = params.row;
              return h('span', {
                'class': {link: true},
                on: {
                  click: () => {
                    this.showRecords(director_topic);
                  }
                }
              }, '查看');
            }
          },
          {
            title: '名称',
            width: 150,
            render: (h, params) => {
              const topic = params.row.topic;
              return h('span', topic.name);
            }
          },
          {
            title: '申请人',
            align: 'center',
            render: (h, params) => {
              const director = params.row.director;
              return h('CustomerPoptip', {
                props: { customer_id: director.id }
              }, director.account);
            }
          },
          {
            title: '月份',
            align: 'center',
            render: (h, params) => {
              const topic = params.row.topic;
              return h('span', topic.wage_month);
            }
          },
          {
            title: '工资总额',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.total_wage));
            }
          },
          {
            title: '含税总额',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.formatPrice(row.pre_tax_wage));
            }
          },
          {
            title: '状态',
            align: 'center',
            width: 130,
            render: (h, params) => {
              const user_flow = params.row.user_flow;
              if (user_flow) {
                return h(UserFlowBase, {
                  props: {
                    user_flow: user_flow,
                    model: params.row
                  },
                  on: {
                    'on-change': () => {
                      this.getDirectorTopics();
                    }
                  }
                });
              }
              return h('span', '已完成');
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 80,
            render: (h, params) => {
              const row = params.row;
              if (FlowUtil.inEditNode(row)) {
                return h('Button', {
                  props: {
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({path: `/team/my_outsource_wage_record/${row.outsource_wage_topic_id}`});
                    }
                  }
                }, '编辑');
              }
              return h('span', '-');
            }
          }
        ],
        record_columns: [
          {
            title: '姓名',
            key: 'account',
            align: 'center',
          },
          {
            title: '合同号',
            align: 'center',
            render: (h, params) => {
              const record = params.row;
              return h(ViewerItem, {
                props: {
                  type: 'OutsourceContract',
                  model_id: record.outsource_contract_id
                }
              }, record.uid);
            }
          },
          {
            title: '工资金额',
            align: 'right',
            width: 100,
            render: (h, params) => {
              const record = params.row;
              return h('span', '¥ ' + this.$util.formatPrice(record.total_wage));
            }
          },
          {
            title: '含税总额',
            align: 'right',
            width: 100,
            render: (h, params) => {
              const record = params.row;
              return h('span', '¥ ' + this.$util.formatPrice(record.pre_tax_wage));
            }
          },
        ]
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
    },
    created() {
      this.getDirectorTopics();
    },
    mounted() {
      //
    },
    methods: {
      searchTypeChange() {
        this.params.page = 1;
        this.getDirectorTopics();
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getDirectorTopics();
      },
      getDirectorTopics() {
        this.loading = true;
        this.$util.ajax.get(this.$util.api.director_outsource_wage_topic_audit, {
          params: this.params
        }).then((response) => {
          return response.data
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleDirectorTopics(data.director_topics);
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      handleDirectorTopics(director_topics) {
        this.director_topics = [];
        director_topics.forEach((dt) => {
          const new_dt = this.$util.clone(dt);
          if (FlowUtil.inEditNode(new_dt) || FlowUtil.isFinished(new_dt) || !new_dt.user_flow) {
            new_dt._disabled = true;
          }
          this.director_topics.push(new_dt);
        });
      },
      selectChange(topics) {
        this.select_topics = topics;
      },
      batchPass() {
        this.batching = true;
        this.$util.ajax.post(this.$util.api.batch_pass_user_flow_node_user, {
          user_flow_ids: this.select_topics.map(t => t.user_flow.id)
        }).then((response) => {
          return response.data
        }).then((res) => {
          if (res.code === 1) {
            this.getDirectorTopics();
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.batching = false;
          this.select_topics = [];
        });
      },
      showRecords(director_topic) {
        this.cur_director_topic = director_topic;
        this.config.modal = true;
      }
    }
  }
</script>
